import { SportEvent } from '@draftkings/sportsbook-common-contracts';

export function isEventStarted(event: SportEvent): boolean {
    return event.status.toLowerCase() === 'started';
}
